import { combineReducers } from 'redux'
import breadcrumbSlice from './reducers/breadcrumb/breadcrumbSlice'
import { modalPlayerReducer } from './reducers/modal-player/modal-player.reducer'
import { snackbarReducer } from './reducers/snackbar/snackbar.reducer'
import { trainingWorkoutReducer } from './reducers/training-workout/training-workout.reducer'
import { modalAddFieldsReducer } from './reducers/modal-add-fields/modal-add-fields.reducer'
import { modalConfirmReducer } from './reducers/modal-confirm/modal-confirm.reducer'
import { profileReducer } from './reducers/profile/profile.reducer'
import summaryAthleteSlice from './reducers/summary-athlete/summaryAthleteSlice'

export const rootReducer = combineReducers({
  breadcrumb: breadcrumbSlice,
  snackbar: snackbarReducer,
  trainingWorkout: trainingWorkoutReducer,
  modalPlayer: modalPlayerReducer,
  modalAddFields: modalAddFieldsReducer,
  modalConfirm: modalConfirmReducer,
  profile: profileReducer,
  summaryAthlete: summaryAthleteSlice
})

export type RootState = ReturnType<typeof rootReducer>
